"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuPopoverClassNames: function() {
        return menuPopoverClassNames;
    },
    useMenuPopoverStyles_unstable: function() {
        return useMenuPopoverStyles_unstable;
    }
});
const _react = require("@griffel/react");
const menuPopoverClassNames = {
    root: 'fui-MenuPopover'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ],
        De3pzq: "fxugw4r",
        sj55zd: "f19n0e5",
        B7ck84d: "f1ewtqcl",
        Bf4jedk: "fl8fusi",
        B2u0y6b: "f1kaai3v",
        B68tc82: "f1p9o1ba",
        a9b677: "f1ahpp82",
        E5pizo: "f1hg901r",
        z8tnut: "f10ra9hq",
        z189sj: [
            "f8wuabp",
            "fycuoez"
        ],
        Byoj8tv: "f1y2xyjm",
        uwmqm3: [
            "fycuoez",
            "f8wuabp"
        ],
        B4j52fo: "f5ogflp",
        Bekrc4i: [
            "f1hqa2wf",
            "finvdd3"
        ],
        Bn0qgzm: "f1f09k3d",
        ibv6hh: [
            "finvdd3",
            "f1hqa2wf"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "fghlq4f",
        h3c5rm: [
            "f1gn591s",
            "fjscplz"
        ],
        B9xav0g: "fb073pr",
        zhjwy3: [
            "fjscplz",
            "f1gn591s"
        ],
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        B93otf3: "f18k4bn6",
        vin17d: "fo1kyvf",
        Ezkn3b: "fetxo7e",
        nyiy2g: "f8x1vz1",
        swvrvq: "f8g0anz",
        Bkovbt3: "fezwn9i",
        hgjdhn: "fz5efge",
        fsy9dk: "f1ydixl4",
        B3ogreh: "f8dgqj5",
        jv49x5: "fnyfnr8",
        Bk7o48c: "fgw77r4",
        Bv12yb3: "ftje0s4",
        z0t1cu: "fi19xcv",
        Bks05zx: "f1mzajhk",
        Bvtglag: "fjp4h9y"
    }
}, {
    d: [
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".fl8fusi{min-width:138px;}",
        ".f1kaai3v{max-width:300px;}",
        ".f1p9o1ba{overflow-x:hidden;}",
        ".f1ahpp82{width:max-content;}",
        ".f1hg901r{box-shadow:var(--shadow16);}",
        ".f10ra9hq{padding-top:4px;}",
        ".f8wuabp{padding-right:4px;}",
        ".fycuoez{padding-left:4px;}",
        ".f1y2xyjm{padding-bottom:4px;}",
        ".f5ogflp{border-top-width:1px;}",
        ".f1hqa2wf{border-right-width:1px;}",
        ".finvdd3{border-left-width:1px;}",
        ".f1f09k3d{border-bottom-width:1px;}",
        ".fzkkow9{border-top-style:solid;}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".fg706s2{border-bottom-style:solid;}",
        ".fghlq4f{border-top-color:var(--colorTransparentStroke);}",
        ".f1gn591s{border-right-color:var(--colorTransparentStroke);}",
        ".fjscplz{border-left-color:var(--colorTransparentStroke);}",
        ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".f18k4bn6{animation-composition:accumulate;}",
        ".fo1kyvf{animation-duration:var(--durationSlower);}",
        ".fetxo7e{animation-timing-function:var(--curveDecelerateMid);}",
        ".f8x1vz1{--fui-positioning-slide-distance-x:0px;}",
        ".f8g0anz{--fui-positioning-slide-distance-y:10px;}",
        ".fezwn9i[data-popper-placement^=right]{--fui-positioning-slide-distance-x:-10px;}",
        ".fz5efge[data-popper-placement^=right]{--fui-positioning-slide-distance-y:0px;}",
        ".f1ydixl4[data-popper-placement^=bottom]{--fui-positioning-slide-distance-x:0px;}",
        ".f8dgqj5[data-popper-placement^=bottom]{--fui-positioning-slide-distance-y:-10px;}",
        ".fnyfnr8[data-popper-placement^=left]{--fui-positioning-slide-distance-x:10px;}",
        ".fgw77r4[data-popper-placement^=left]{--fui-positioning-slide-distance-y:0px;}",
        ".ftje0s4{animation-name:f5j8bii,f79suad;}"
    ],
    k: [
        "@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}",
        "@keyframes f79suad{from{transform:translate(var(--fui-positioning-slide-distance-x), var(--fui-positioning-slide-distance-y));}}"
    ],
    m: [
        [
            "@media (prefers-reduced-motion){.fi19xcv[data-popper-placement]{animation-duration:1ms;}}",
            {
                m: "(prefers-reduced-motion)"
            }
        ],
        [
            "@media (prefers-reduced-motion){.f1mzajhk[data-popper-placement]{animation-name:f5j8bii;}}",
            {
                m: "(prefers-reduced-motion)"
            }
        ]
    ],
    t: [
        "@supports not (animation-composition: accumulate){.fjp4h9y[data-popper-placement]{animation-name:f5j8bii;}}"
    ]
});
const useMenuPopoverStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuPopoverClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useMenuPopoverStyles.styles.js.map
